// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__AQ2FE","empty":"ModalGraph_empty__3hkL0"};